import React from 'react';
import PropTypes from 'prop-types';
import { Label, StyledInput } from 'components/ui/inputs/Input/styles';
import ErrorMessage from 'components/ui/labels/ErrorMessage';
import LabelWithTooltip from './LabelWithTooltip';

const Input = ({
  button,
  id,
  errors,
  labelText,
  touched,
  name,
  tooltipText,
  ...props
}) => (
  <Label htmlFor={id} hasButton={!!button}>
    <span className="label-text">
      <LabelWithTooltip labelText={labelText} tooltipText={tooltipText} />
    </span>
    <div className="input-wrapper">
      <StyledInput name={name} {...props} hasButton={!!button} />
      {button ? button : null}
    </div>
    {touched && touched[name] && errors && errors[name] && (
      <ErrorMessage>{errors[name]}</ErrorMessage>
    )}
  </Label>
);

Input.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  /** Renders adjacent to input */
  button: PropTypes.any,
  errors: PropTypes.object,
  touched: PropTypes.object,
  labelText: PropTypes.string,
  tooltipText: PropTypes.string,
};

Input.displayName = 'Input';

export default Input;
